<div *ngIf="drivers; else noDrivers">
    <p-table
        [paginator]="true"
        [rows]="9"
        [value]="drivers"
        [rowsPerPageOptions]="[10, 15, 20]"
        responsiveLayout="scroll"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>{{"FIRST_NAME" | translate}}</th>
                <th>{{'SURNAME' | translate}}</th>
                <th>{{'IDENTIFICATION_TYPE' | translate}}</th>
                <th>{{'IDENTIFICATION_NUMBER' | translate}}</th>
                <th>{{'DATE_OF_BIRTH' | translate}}</th>
                <th>{{'Nationality' | translate}}</th>
                <th>{{'GENDER' | translate}}</th>
                <th>{{'STATUS' | translate}}</th>
                <th>{{'ACTIONS' | translate}}</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-driver>
            <tr>
                <td>
                    <span class="p-column-title">First Name</span>
                    {{ driver.firstname }}
                </td>
                <td>
                    <span class="p-column-title">Last Name</span>
                    {{ driver.surname }}
                </td>
                <td>
                    <span class="p-column-title">ID Type</span>
                    {{ driver.identificationType | translate}}
                </td>
                <td>
                    <span class="p-column-title">ID Number</span>
                    {{ driver.identificationNumber }}
                </td>
                <td>
                    <span class="p-column-title">D.O.B</span>
                    {{ driver.dateOfBirth | date }}
                </td>
                <td>
                    <span class="p-column-title">Nationality</span>
                    {{ driver.nationality }}
                </td>
                <td>
                    <span class="p-column-title">Gender</span>
                    {{ driver.gender | translate }}
                </td>
                <td>
                    <span class="p-column-title">Status</span>
                    {{ driver.status | translate}}
                </td>
                <td>
                    <p-button
                        class="table-button"
                        [pTooltip]="'View driver details'|translate"
                        icon="pi pi-info-circle"
                        [rounded]="true"
                        (onClick)="viewDriverClicked(driver.id)"
                        [text]="true"
                        severity="info"
                    />
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
<ng-template #noDrivers>
    <div class="flex align-items-center ">
        <i class="pi pi-exclamation-triangle mr-4"></i
        ><span>{{ 'NO_VEHICLES'}}</span>
    </div>
</ng-template>
